import { FC } from 'react';
import { DynamicAttraction as DynamicAttr } from 'ts/dynamic/interfaces/DynamicResponse';
import { dateFormat } from 'utils/dynamic/i18n';
import Button from 'components/ui/Button/Button';
import { useTranslation } from 'react-i18next';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface DynamicAttractionProps {
  ticket: DynamicAttr;
  onClickChange: (id: number) => void;
}

const DynamicAttraction: FC<DynamicAttractionProps> = ({ ticket, ...props }) => {
  const { t } = useTranslation();
  return (
    <div className="dyn-hotel mb-30">
      <div className="dyn-hotel-img">
        <img src={ticket.image} alt="" />
      </div>
      <div className="dyn-hotel-info">
        <div>
          <span>{ticket.categoryDesc} - </span>
          <span className="text-bold text-md">{ticket.showName}</span>
        </div>
        <div>
          <span>{ticket.ticketDesc}</span>
        </div>
        <div>{dateFormat(ticket.eventDate, 'dd/MM/yyyy - HH:mm')}</div>
        <div>
          {ticket.city}, {ticket.country} - {ticket.vanueDesc}
        </div>
      </div>
      <div className="flex-center flex-one">
        <Button title={t('change_choice')} onClick={() => props.onClickChange(ticket.id)} />
      </div>
    </div>
  );
};

export default withErrorBoundary(DynamicAttraction, 'DynamicAttraction');
